import * as React from 'react';

import { useKeydownSubscription } from 'hooks/useKeydownSubscription';
import { useBasicFormStore, useEditFormStore } from 'stores/local';

import s from './EditFormPage.module.scss';
import {
  CreateFormPageDrawer,
  EditFormTable,
  AddFieldsHint,
  SaveModal,
} from './components';
import { COMBINATIONS } from './config/keydownCombinations';

const EditFormPage: React.FC = () => {
  const { handleCustomFieldAdd } = useBasicFormStore();

  const { editFormStore } = useEditFormStore();

  const handleCustomFieldAddEvent = React.useCallback(() => {
    handleCustomFieldAdd();
  }, [handleCustomFieldAdd]);

  useKeydownSubscription([
    {
      combinations: COMBINATIONS.OPEN_CATALOG_DRAWER,
      handler: editFormStore.catalogDrawerControllerStore.open,
    },
    {
      combinations: COMBINATIONS.ADD_CUSTOM_FIELDS,
      handler: handleCustomFieldAddEvent,
    },
  ]);

  return (
    <>
      <div className={s.page}>
        <AddFieldsHint />
        <div className={s.page__table}>
          <EditFormTable />
        </div>
      </div>
      <CreateFormPageDrawer />
      <SaveModal />
    </>
  );
};

export default EditFormPage;
